import styled from "styled-components";
import { theme } from "../theme";

export const StyledMainContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 5rem 0;
  @media (max-width: 768px) {
  }
`;

export const StyledAuthLogoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-bottom: 2rem;
  svg {
    width: 80px;
    height: 80px;
  }
`;

export const StyledEmptyDataContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  border: 2px solid ${theme.backgroundColor.primaryGray};
  min-height: 200px;
  background-color: ${theme.backgroundColor.secondaryWhite};
`;

export const StyledFormContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  width: 100%;
  // @media (max-width: 768px) {
  //   margin-bottom: 30px;
  // }
`;

export const StyledGeneratorContainer = styled.div<{
  padding?: string;
}>`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: fit-content;
  min-width: 80%;
  margin: 0 auto;
  border: 2px solid ${theme.textColor.primaryGray};
  padding: ${(props) => props.padding || "24px 0 24px 24px"};
  @media (max-width: 990px) {
    width: 90%;
    padding: 16px;
  }
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    padding: 16px;
    width: 85%;
  }
`;

export const StyledTableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  margin-bottom: 34px;
  span {
    display: block;
    font-size: 16px;
    margin-top: 16px;
    text-decoration: underline;
    font-weight: 500;
    cursor: pointer;
    svg {
      position: relative;
      top: 3px;
    }
  }
`;

export const StyledPdfPage = styled.div`
  display: none;
  height: 0;
  width: 0;
  position: absolute;
`;
